import * as tslib_1 from "tslib";
var PitSourceActivityVersion_1;
import { jsonMember, jsonObject } from "typedjson";
import { PitActivityDonor } from "./pit-activity-donor";
/** Версия мероприятия «донора» */
let PitSourceActivityVersion = PitSourceActivityVersion_1 = class PitSourceActivityVersion {
    /** Версия мероприятия «донора» */
    constructor() {
        /** Мероприятие «донор» */
        this._activity = new PitActivityDonor();
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get code() {
        return this._code;
    }
    set code(value) {
        this._code = value;
    }
    get activity() {
        return this._activity;
    }
    set activity(value) {
        this._activity = value;
    }
    static from(activityVersion) {
        let result = new PitSourceActivityVersion_1();
        result.id = activityVersion.id;
        result.code = activityVersion.code;
        result.activity = PitActivityDonor.from(activityVersion.activity);
        return result;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitSourceActivityVersion.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "code", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitSourceActivityVersion.prototype, "_code", void 0);
tslib_1.__decorate([
    jsonMember({ name: "activity", constructor: PitActivityDonor, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", PitActivityDonor)
], PitSourceActivityVersion.prototype, "_activity", void 0);
PitSourceActivityVersion = PitSourceActivityVersion_1 = tslib_1.__decorate([
    jsonObject
], PitSourceActivityVersion);
export { PitSourceActivityVersion };
